<template>
  <div>
    <template v-if="active">
      <LoadingSpinner
        :opaque="opaque"
        :fullscreen="fullscreen"
        :statusText="statusText"
      />
    </template>
    <template v-else>
      <slot name="default" />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { LoadingSpinner } from '@/components/library/loaders';

export default defineComponent({
  name: 'LoadingGate',
  components: {
    LoadingSpinner,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    opaque: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
    statusText: {
      type: String,
      required: false,
    },
  },
});
</script>
